<template><!-- svgo-optimised -->
<svg class="icon icon__minus" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g opacity=".7"><circle cx="10" cy="10" fill="#fff" r="10" opacity=".85"/></g><path d="M15.116 10.167h-9.9" stroke="#000"/></svg>
</template>